function sliderNavigation(slider, sliderElement) {
  const arrowLeft = sliderElement.parentElement.querySelector('.arrow-left');
  const arrowRight = sliderElement.parentElement.querySelector('.arrow-right');

  function init() {
    arrowLeft.addEventListener('click', () => slider.prev());
    arrowRight.addEventListener('click', () => slider.next());
  }

  slider.on('created', () => {
    init();
  });
}

document.querySelectorAll('.product-slider').forEach(sliderElement => {
  new KeenSlider(
    sliderElement,
    {
      initial: 0,
      mode: 'snap',
      slides: {
        perView: 'auto',
      },
    },
    [slider => sliderNavigation(slider, sliderElement)]
  );
});